import styled from 'styled-components';

export const ModalCenterFont = styled.div `
    display: ${props => props.appear ? 'block': 'none'};
    
    position: fixed;
    z-index: 9999;

    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .6);

    #modal {
        position: absolute;
        top: 30%;
        left: 50%;
        margin-top: -108px;
        margin-left: -250px;
    }
    
    .br-modal-body {
        margin: 0 0 var(--spacing-scale-1x) !important;
    }

`;
export const SelectContainer = styled.div `
    height: 64px;
    display: grid;

    //border: 1px solid;
    //border-color: red;
`;
export const ContentContainer3 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 790;
  margin: 0px auto;
`
export const ContentContainerTable = styled.div`
  width: 590px;
  margin-bottom: 20px;

  @media (max-width: 1000px) {
    width: 410px;
  }
`
export const ContentContainer = styled.div `
    margin: 0px auto;
    max-width: 1000px;
`;

export const InputContainer = styled.div `
    display: grid;
    margin-right: 30px;

    //border: 1px solid;
    //border-color: red;
`;